import { cn } from "@/lib/utils";

const COLOR_MAP = {
  tiger: {
    badge: "bg-tiger-orange text-white",
    accent: "bg-sun",
  },
  jungle: {
    badge: "bg-jungle text-white",
    accent: "bg-jungle-leaf text-white",
  },
};

export default function TopicSection({ topic, index, children }) {
  const colors = COLOR_MAP[topic.color] || COLOR_MAP.tiger;
  const reversed = index % 2 === 1;

  return (
    <section
      id={topic.id}
      className="relative py-12 sm:py-20"
      data-testid={`topic-${topic.id}`}
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div
          className={cn(
            "grid items-start gap-8 lg:gap-14",
            "lg:grid-cols-[260px_1fr]",
            reversed && "lg:grid-cols-[1fr_260px]",
          )}
        >
          {/* Number badge column */}
          <div
            className={cn(
              "flex flex-col gap-4 lg:sticky lg:top-28 lg:self-start",
              reversed && "lg:order-2",
            )}
          >
            <div
              className={cn(
                "relative inline-flex h-28 w-28 items-center justify-center rounded-3xl border-[4px] border-tiger-deep shadow-stickerLg",
                colors.badge,
              )}
            >
              <span className="font-heading text-5xl font-bold leading-none">
                {topic.number}
              </span>
              <span className="absolute -right-3 -top-3 grid h-12 w-12 place-items-center rounded-2xl border-[3px] border-tiger-deep bg-white text-2xl shadow-sticker">
                {topic.emoji}
              </span>
            </div>
            <div>
              <p className="font-body text-xs font-bold uppercase tracking-widest text-tiger-deep/60">
                {topic.subtitle}
              </p>
              <h2 className="mt-1 font-heading text-3xl font-bold text-tiger-deep sm:text-4xl">
                {topic.title}
              </h2>
            </div>
          </div>

          {/* Content column */}
          <div className={cn("space-y-6", reversed && "lg:order-1")}>
            <div className="rounded-3xl border-[4px] border-tiger-deep bg-white p-6 shadow-stickerLg sm:p-8">
              <p className="font-body text-lg leading-relaxed text-tiger-deep sm:text-xl">
                {topic.intro}
              </p>
            </div>

            {children}

            {topic.funFact && (
              <div
                className={cn(
                  "relative rounded-3xl border-[4px] border-tiger-deep p-5 sm:p-6 shadow-sticker",
                  colors.accent,
                )}
                data-testid={`fun-fact-${topic.id}`}
              >
                <span className="absolute -top-4 left-6 inline-flex items-center gap-1 rounded-full border-[3px] border-tiger-deep bg-white px-3 py-1 font-heading text-xs font-bold uppercase tracking-wider text-tiger-deep shadow-sticker">
                  ✨ Fun Fact
                </span>
                <p className="font-body text-lg font-bold text-tiger-deep sm:text-xl">
                  {topic.funFact}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
